import $api from 'http'
import $apiJSON from 'http/apiJSON'



// ── Категории ───────────────────────────────────────────────────────────────

export const getDocumentCategories = () =>
    $apiJSON.get(`komurconnection/categories/`)

// ── Папки НПА ────────────────────────────────────────────────────────────────

/** Список всех папок (с полем doc_count). */
export const getNPAFolders = () =>
    $apiJSON.get(`komurconnection/npa-folders/`)

/** Детали папки + документы внутри. */
export const getNPAFolderDetail = (id) =>
    $apiJSON.get(`komurconnection/npa-folders/${id}/`)

export const createNPAFolder = (data) =>
    $apiJSON.post(`komurconnection/npa-folders/`, data)

export const updateNPAFolder = (id, data) =>
    $apiJSON.patch(`komurconnection/npa-folders/${id}/`, data)

export const deleteNPAFolder = (id) =>
    $apiJSON.delete(`komurconnection/npa-folders/${id}/`)

// ── НПА ─────────────────────────────────────────────────────────────────────

export const getNPAList = (params = {}) =>
    $apiJSON.get(`komurconnection/npa/`, { params })

export const getNPADetail = (id) =>
    $apiJSON.get(`komurconnection/npa/${id}/`)

/** Upload new NPA (multipart form data). */
export const createNPA = (formData) =>
    $api.post(`komurconnection/npa/`, formData, { headers: { 'Content-Type': undefined } })

export const updateNPA = (id, data) =>
    $apiJSON.patch(`komurconnection/npa/${id}/`, data)

export const deleteNPA = (id) =>
    $apiJSON.delete(`komurconnection/npa/${id}/`)

/** Increments download_count and returns { file_url }. */
export const downloadNPA = (id) =>
    $apiJSON.post(`komurconnection/npa/${id}/download/`)

// ── Мои документы ───────────────────────────────────────────────────────────

/** Все документы текущего сотрудника (с полем folder). При search — ищет по всем. */
export const getMyDocuments = (params = {}) =>
    $apiJSON.get(`komurconnection/my-documents/`, { params })

// ── Мои папки ────────────────────────────────────────────────────────────────

export const getMyFolders = () =>
    $apiJSON.get(`komurconnection/my-folders/`)

export const createMyFolder = (data) =>
    $apiJSON.post(`komurconnection/my-folders/`, data)

export const updateMyFolder = (id, data) =>
    $apiJSON.patch(`komurconnection/my-folders/${id}/`, data)

export const deleteMyFolder = (id) =>
    $apiJSON.delete(`komurconnection/my-folders/${id}/`)

export const getMyDocumentDetail = (id) =>
    $apiJSON.get(`komurconnection/my-documents/${id}/`)

/** Upload a new document (multipart form data, fields: file, title, description). */
export const uploadDocument = (formData) =>
    $api.post(`komurconnection/my-documents/`, formData, { headers: { 'Content-Type': undefined } })

/** Rename / update description of an owned document. */
export const updateDocument = (id, data) =>
    $apiJSON.patch(`komurconnection/my-documents/${id}/`, data)

export const deleteDocument = (id) =>
    $apiJSON.delete(`komurconnection/my-documents/${id}/`)

/** Increments download_count and returns { file_url }. */
export const downloadDocument = (id) =>
    $apiJSON.post(`komurconnection/my-documents/${id}/download/`)

/**
 * Toggle a visibility flag on a document the user owns.
 * @param {number} id - document id
 * @param {'is_open'|'show_in_dept'|'show_in_transit'} flag
 */
export const toggleDocumentFlag = (id, flag) =>
    $apiJSON.patch(`komurconnection/my-documents/${id}/toggle/${flag}/`)

// ── Отдел ────────────────────────────────────────────────────────────────────

/** Documents shared to the requesting user's department (show_in_dept=True). */
export const getDeptDocuments = () =>
    $apiJSON.get(`komurconnection/dept-documents/`)

// ── Транзит ──────────────────────────────────────────────────────────────────

/** All documents visible to all employees (show_in_transit=True). */
export const getTransitDocuments = () =>
    $apiJSON.get(`komurconnection/transit/`)

// ── Кыргызкомур иерархия ────────────────────────────────────────────────────

/** All departments with document count summaries. */
export const getKyrgyzkomur = () =>
    $apiJSON.get(`komurconnection/kyrgyzkomur/`)

/** Department detail: employees + their open docs + dept docs. */
export const getKyrgyzkomurDept = (deptId) =>
    $apiJSON.get(`komurconnection/kyrgyzkomur/${deptId}/`)
